module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAvklEQVRIx2NgGAWoYMUMWiGG/89phWhp9O5yZiLR9jJ2ICJePcM9Sw6C6IaD8PWu4vr8iCWdlUAGkEuMLqKMBhr359ef6OiwL5++/P/7H8iljtE3rHle3bj6/et3d2/3yVMmP75/H8gFChI2miBgYWG5cukK0LGVlZXRPm5z7DWAXKAgddJ+fn7+xfMXa2tqGxsa55flAblUy1Y8PDxA43q6eupq6oAMIJfKuXHpVBYgGs2NZCOisgx5aGgaDQArpGuB1q8doAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ug.png
// module id = 950
// module chunks = 0